import { render, staticRenderFns } from "./ReIconsTemplate.vue?vue&type=template&id=c3470bb6&scoped=true"
import script from "./ReIconsTemplate.vue?vue&type=script&lang=js"
export * from "./ReIconsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3470bb6",
  null
  
)

export default component.exports